import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/api-queries`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAll({commit}, payload: {query: object}) {
    return axiosInstance.get(baseUrl, {
      params: payload?.query || {},
    }).then((data) => data.data);
  },
  getDetails({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  getTimeExec(
    {commit},
    payload: {
        query: {
            services: string[],
            direction: string,
            methods: string[],
            statuses: Array<number|null>,
            startTime: Date|null,
            endTime: Date|null,
            minExecutionTime: number,
            userId: number,
        },
  }) {
    return axiosInstance.get(`${baseUrl}/time-execution`, {
      params: payload?.query || {},
    })
    .then((data) => data.data);
  },
  getStatusExec(
    {commit},
    payload: {
        query: {
            services: string[],
            direction: string,
            methods: string[],
            statuses: Array<number|null>,
            startTime: Date |null,
            endTime: Date|null,
            minExecutionTime: number,
            userId: number,
      },
  },
    ) {
    return axiosInstance.get(`${baseUrl}/status-execution`, {
      params: payload ?.query || {},
    })
    .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
